import { AccountLayout } from '../../layouts';
import { AuthSelectionScreenForLoginForm } from '../../components/AuthSelectionScreenForLoginForm/AuthSelectionScreenForLoginForm';

export const AuthSelectionScreenForLoginPage = () => {
  return (
    <AccountLayout
      contents={<AuthSelectionScreenForLoginForm />}
      contentColumns={5}
    />
  );
};
